export function getKMCSettings() {
  return window.klevu_ui_kmc_settings
}
